import { Notification_Severity } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { NotificationUrgency, UrgencyStyle } from '../types';

const SEVERITY_TO_URGENCY: Record<Notification_Severity, NotificationUrgency> =
  {
    [Notification_Severity.ERROR]: 'high',
    [Notification_Severity.WARNING]: 'mid',
    [Notification_Severity.UNSPECIFIED]: 'none',
    [Notification_Severity.INFO]: 'none',
  };

export const mapSeverityToUrgency = (
  severity: Notification_Severity,
): NotificationUrgency => SEVERITY_TO_URGENCY[severity];

export const URGENCY_CONFIG: Record<NotificationUrgency, UrgencyStyle> = {
  high: {
    iconBgColor: '#F54F46',
    iconColor: '#FFFFFF',
    urgencyMessageKey: 'high',
    urgencyBgColor: '#FEECF0',
    urgencyBorderColor: '#D32F2F',
    urgencyTextColor: '#D32F2F',
  },
  mid: {
    iconBgColor: '#FDBA63',
    iconColor: '#FFFFFF',
    urgencyMessageKey: 'mid',
    urgencyBgColor: '#FFF8E1',
    urgencyBorderColor: '#F57C00',
    urgencyTextColor: '#F57C00',
  },
  none: {
    iconBgColor: '#01A567',
    iconColor: '#FFFFFF',
  },
};
